import {Component} from '@angular/core';
import {MenuComponent} from '../../menu/menu.component';

@Component({
  selector: 'app-menu-toggle',
  imports: [
    MenuComponent
  ],
  templateUrl: './menu-toggle.component.html'
})
export class MenuToggleComponent {
  showMenu = false
}
